
<template>
      <span @click="showInputBlock" v-click-outside="hideInputBlock" :style=customStyle>
        <span style="display: flex;" v-show="showInputCustomPrice">
          &euro;&nbsp;<input
          type="text"
          class="custom-price-input"
          v-model="customTotalInput"
          @change="changeCustomPrice"
          ref="input"
        />
        </span>
        <span v-show="!showInputCustomPrice">
          <span v-if="customTotal > 0 || !hideWhenEmpty">{{ totalCustomPrice() }}</span>
          <span v-else class="invisible-price">&nbsp;</span>
        </span>
    </span>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { moneyFormat } from '@/mixins/moneyFormat'
export default {
  props: {
    customStyle: {
      type: [String],
      required: false
    },
    customPrice: {
      type: [String, Number],
      required: true
    },
    hideWhenEmpty: {
      type: [Boolean],
      required: false
    }
  },
  data () {
    return {
      customTotal: parseFloat(this.customPrice),
      customTotalInput: parseFloat(this.customPrice) / 100,
      showInputCustomPrice: false
    }
  },
  mixins: [moneyFormat],
  methods: {
    totalCustomPrice () {
      let total = parseInt(this.customTotal)
      return this.formatMoney(total, 'EUR')
    },
    hideInputBlock () {
      this.showInputCustomPrice = false
    },
    showInputBlock () {
      this.showInputCustomPrice = true
    },
    changeCustomPrice () {
      this.customTotal = this.customTotalInput * 100
      this.$emit('changeCustomPrice', this.customTotal)
    }
  },
  watch: {
    'showInputCustomPrice': {
      handler () {
        setTimeout(() => this.$refs['input'].focus(), 100)
      }
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style>
input.custom-price-input{
  font-family: "Open Sans Bold";
  font-weight: bold;
  font-size: 16px;
  border: 1px solid rgba(65, 65, 65, 65);
  width: 50px;
  margin-right: 10px;
}
.invisible-price {
  position: absolute;
  width: 70px;
  height: 20px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/PriceInput.vue